import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import SubmitButton from 'components/atoms/buttons/SubmitButton'

const styles = theme => ({
  root: {
    ...theme.components.popover,
    width: 450,
  },
  description: {
    margin: `${theme.spacing(2)}px 0 ${theme.spacing(4)}px`,
  },
})

const DeleteAdminBlocked = ({ classes, data }) => (
  <div className={classes.root}>
    <Typography variant="h1">{data.title || 'Sorry,'}</Typography>
    <Typography className={classes.description}>
      {data.message ||
        'Because you are the only admin, we cannot remove you from the project. If you wish to delete this project, please contact GoodNature at info@goodnature.co.nz'}
    </Typography>
    <SubmitButton
      size="medium"
      color="primary"
      variant="primary"
      onClick={data.onConfirm}>
      Okay
    </SubmitButton>
  </div>
)

DeleteAdminBlocked.propTypes = {
  data: PropTypes.object,
  classes: PropTypes.object,
  handleClose: PropTypes.func,
}

export default withStyles(styles)(DeleteAdminBlocked)



// WEBPACK FOOTER //
// ./src/components/molecules/DeleteAdminBlocked.js